"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = mergeRequestOptions;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function mergeRequestOptions(defaults, options) {
  var defaultHeaders = defaults.headers,
      defaultsCopy = _objectWithoutProperties(defaults, ["headers"]);

  var optionsHeaders = options.headers,
      optionsCopy = _objectWithoutProperties(options, ["headers"]);

  var results = _extends({}, defaultsCopy, optionsCopy);
  results.headers = _extends({}, defaultHeaders, optionsHeaders);
  return results;
}